import DuckEntity from './DuckEntity';

export default function PageableDuck(nameOrDuck, options = {}) {
  const duck = new DuckEntity(nameOrDuck, options);

  const reducer = (state = duck.initialState, action) => {
    const result = { ...duck.reducer(state, action) };
    if (action.type === duck.types.LOAD_SUCCESS) {
      const {
        payload: {
          result: {
            paging: {
              count,
              page,
              per_page: perPage,
              total
            }
          }
        }
      } = action;
      result[action.stateKey].count = count;
      result[action.stateKey].page = page;
      result[action.stateKey].perPage = perPage;
      result[action.stateKey].total = total;
    }
    return result;
  };

  const all = (state, stateKey = '_all') => {
    const result = duck.all(state, stateKey);

    if (state[duck.name][stateKey]) {
      const {
        count,
        page,
        perPage,
        total
      } = state[duck.name][stateKey];

      result.count = count;
      result.page = page;
      result.perPage = perPage;
      result.total = total;
    }

    return result;
  };

  return {
    ...duck,
    reducer,
    all
  };
}
